import type { Project } from '../../types';
import BaseModal from '../common/BaseModal';
import { asset } from '../../utils/asset';
import styles from './ProjectModal.module.css';

interface Props {
  project: Project | null;
  onClose: () => void;
  onImageClick: (src: string) => void;
}

export default function ProjectModal({ project, onClose, onImageClick }: Props) {
  if (!project) return null;
  const imgSrc = asset(
    project.image === 'svg' ? 'assets/images/lake_michigan.png' : project.image,
  );
  return (
    <BaseModal
      open={!!project}
      onClose={onClose}
      variant="project"
      labelledBy="project-modal-title"
    >
      <div className={styles.imageSection}>
        <button type="button" aria-label={`Expand image: ${project.title}`} className={styles.imageWrap} onClick={() => onImageClick(imgSrc)}>
          <img src={imgSrc} alt={project.title} className={styles.image} />
          <span className={styles.expandHint}>Click the image to expand</span>
        </button>
      </div>
      <div className={styles.infoSection}>
        <div className={styles.badges}>
          <span className={styles.category}>{project.category}</span>
          {project.subcategory && (
            <span className={styles.subcategory}>{project.subcategory}</span>
          )}
        </div>
        <h2 id="project-modal-title" className={styles.title}>
          {project.title}
        </h2>
        <p className={styles.lead}>{project.description}</p>
        {project.fullDescription && (
          <p className={styles.description}>{project.fullDescription}</p>
        )}
      </div>
    </BaseModal>
  );
}
